import React from 'react';
import { dsnCN } from "../../../hooks/helper";

function MenuContent({ className }) {
    const socialData = [
        { link: "https://www.youtube.com/@mystirien?sub_confirmation=1 ", name: "Youtube." },
        { link: "https://open.spotify.com/artist/7435s1bwxVh0coVrNSX7QD?si=x-OmYCFdQSCq_3WGoXlTOA", name: "Spotify." },
        { link: "https://www.instagram.com/Mystirien", name: "Instagram." },
        { link: "https://x.com/mystirien", name: "X." }
    ];
    return (
        <div className={dsnCN('container-content  d-flex flex-column justify-content-center', className)}>
            <div className="nav__info">
                <div className="nav-content">
                    <h5 className="sm-title-block mb-10">Studio</h5>
                    <p>
                        Coming soon
                    </p>

                </div>
                <div className="nav-content mt-30">
                    <h5 className="sm-title-block mb-10">Contact</h5>
                    <p className="links over-hidden">
                        <a className="link-hover" href="mailto:whisper@mystirien.com"
                            data-hover-text="whisper@mystirien.com">whisper@mystirien.com</a>
                    </p>
                </div>
            </div>
            <div className="nav-social nav-content mt-30">
                <div className="nav-social-inner p-relative">
                    <h5 className="sm-title-block mb-10">Follow me</h5>
                    <ul>
                        {socialData.map((item, index) =>
                            <li key={index}>
                                <a href={item.link} target="_blank" rel="nofollow noopener noreferrer">{item.name}</a>
                            </li>)}
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default MenuContent;